module.exports = __webpack_public_path__ + "assets/img/618_bg.4a1f93ef.png";